export enum FORM_FIELD {
  FORMATS = 'formats',
  TARGETING_DEVICES = 'targetingDevices',
  // PUBLISHERS = 'publishers',
  FLIGHT_DATES = 'flightDates',
  SKYRISE_POWERED = 'poweredBySkyrise'
}
